import { Accordion, ActionButton, Disclosure, DisclosurePanel, DisclosureTitle, Divider, Flex, Heading, TextArea, View } from "@adobe/react-spectrum";
import { useEffect, useRef, useState } from "react";
import { Check, ExclamationTriangle } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
interface ICommentSectionProps{
    comment:string;
    keywords:string;
    onChange:(data:{comment:string,keywords:string})=> void;
    expandedSectionKey:any
    setExpandedSectionKey:(data:any)=>void;
    validationErrors:any
  setValidationErrors : (data:any)=>void;
  fieldConfig:any
  validationStatus:any
  setValidationStatus:(data:any)=>void;
}
export const CommentSection: React.FC<ICommentSectionProps> = ({ comment, keywords, onChange,expandedSectionKey,setExpandedSectionKey,validationErrors,
  setValidationErrors,
  fieldConfig,
  validationStatus,
  setValidationStatus }) => {
const [isSectionRequired,setIsSectionRequired] = useState(false);
const { t } = useTranslation('contacts');
const _t = (key: string) => t(`addNewCompany.${key}`, { ns: 'contacts' });
const _tt = (key: string) => t(`contact_common.${key}`, { ns: 'contacts' });
const firstInputRef = useRef<any>(null);
      useEffect(() => {
          if(fieldConfig?.comment?.required
            ||fieldConfig?.keywords?.required
          ){
            setValidationStatus((prev:any) => ({ ...prev, ['commentSection']: false }));
            setIsSectionRequired(true)
          } 
        }, [fieldConfig]);

  const handleSectionExpandedChange = () => {
    setExpandedSectionKey((prevKey:any) => prevKey.has("commentSection") ? new Set() : new Set(["commentSection"]));
  };

const handleConfirm = ()=>{
    const errors:any = {};
    if(fieldConfig?.comment?.required && comment === ''){
      errors.comment = 'Comment is required';
    }
    if(fieldConfig?.keywords?.required && keywords === ''){
      errors.keywords = 'keywords is required';
    }
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      setValidationStatus((prev:any) => ({ ...prev, ['commentSection']: false }));
      return;
    }
    setValidationStatus((prev:any) => ({ ...prev, ['commentSection']: true }));
    handleSectionExpandedChange();
  }

  useEffect(()=>{
    if (expandedSectionKey?.has?.("commentSection")) {
    if (firstInputRef.current) {
        firstInputRef.current.focus();
      }
    }
  },[expandedSectionKey])

const validateRequiredFields = ()=>{
   const errors:any = {};
    if(fieldConfig?.comment?.required && comment === ''){
      errors.comment = 'Comment is required';
    }
    if(fieldConfig?.keywords?.required && keywords === ''){
      errors.keywords = 'keywords is required';
    }
    if (Object.keys(errors).length > 0) {
      setValidationStatus((prev:any) => ({ ...prev, ['commentSection']: false }));
      return;
    }
    setValidationStatus((prev:any) => ({ ...prev, ['commentSection']: true }));
}

  return (
    <Accordion isQuiet expandedKeys={expandedSectionKey} onExpandedChange={handleSectionExpandedChange}>
      <Disclosure id="commentSection"> 
        <DisclosureTitle>
          <Flex justifyContent="space-between" alignItems="center" width="100%">
            <View><span>{_tt(`comment`)}</span><span style={{color:'#B0BEC5',fontFamily:'Adobe Clean'}}>{isSectionRequired && ` (${_tt('required')})`}</span></View>
            {validationStatus.commentSection ? <Check size={20} color="#1976D2" /> :<ExclamationTriangle size={20} color="#FF9800" />}
          </Flex>
        </DisclosureTitle>
        <DisclosurePanel>
        <Divider size='M' UNSAFE_style={{marginBottom:10}}/>
        <Flex direction="column" gap="size-100" width="100%">
      <TextArea
        ref={firstInputRef}
        label={_tt("comment")}
        value={comment}
        onChange={(newComment) => onChange({ comment: newComment, keywords })}
        onBlur = {()=>validateRequiredFields()}
        width='100%'
        isRequired={fieldConfig?.comment?.required}
        errorMessage={fieldConfig?.comment?.required && validationErrors.comment}
        validationState={fieldConfig?.comment?.required && validationErrors.comment ? comment === '' ? 'invalid' : 'valid' : undefined}
      />
      <TextArea
        label={_tt("keywords")}
        value={keywords}
        onChange={(newKeywords) => onChange({ comment, keywords: newKeywords })}
        onBlur = {()=>validateRequiredFields()}
        width='100%'
        isRequired={fieldConfig?.keywords?.required}
        errorMessage={fieldConfig?.keywords?.required && validationErrors.keywords}
        validationState={fieldConfig?.keywords?.required && validationErrors.keywords ? keywords === '' ? 'invalid' : 'valid' : undefined}
      />
    </Flex>
    <Flex justifyContent={'end'} marginTop={10} gap={'size-50'}>
                        <View marginTop={12}>
                          <ActionButton onPress={handleConfirm} isQuiet UNSAFE_style={{color:'#1976D2'}}><Check size={22} color='#1976D2' /> {_tt('button_confirm')}</ActionButton> {/*active:#1976D2, disabled:#B0BEC5*/}
                        </View>
                      </Flex>
                      <Divider size='M' UNSAFE_style={{marginTop:10}}/>
        </DisclosurePanel>
        </Disclosure>
    </Accordion>
);
}